import React, { useEffect, useState } from "react";
import { Link, useLocation, useMatch, useParams, withRouter } from "react-router-dom";
import { IoIosArrowForward, IoIosPeople} from 'react-icons/io'
import { RxDashboard} from 'react-icons/rx'
import { AiOutlineTeam } from "react-icons/ai";
import { BsFlag } from "react-icons/bs";
import { BiSolidMobile } from "react-icons/bi";
// import FeatherIcon from "feather-icons-react";
// import { Scrollbars } from "react-custom-scrollbars";
// import { LogoImg, LogoSmallImg } from "../_components/imagepath";

const Sidebar = ({secondaryColor,textColor}) => {
  const [isSideMenu, setSideMenu] = useState("");
  const [isSideMenuLevel, setSideMenuLevel] = useState("");
  const [isSideMenuLevel2, setSideMenuLevel2] = useState("");
  // const {someParam} = useParams()
  // const match = useMatch()
  // console.log(match,'mmmmmmmm');
  const loction = useLocation()


  const toggleSidebar = (value) => {
    console.log(value);
    setSideMenu(value);
  };
  const toggleSidebar1 = (value) => {
    console.log(value);
    setSideMenuLevel(value);
  };
  const toggleSidebar2 = (value) => {
    console.log(value);
    setSideMenuLevel2(value);
  };

  useEffect(() => {
    function handleMouseOver(e) {
      e.stopPropagation();
      if (document.body.classList.contains('mini-sidebar') && document.querySelector('#toggle_btn').offsetParent !== null) {
        var targ = e.target.closest('.sidebar');
        if (targ) {
          document.body.classList.add('expand-menu');
          document.querySelectorAll('.subdrop + ul').forEach((ul) => ul.style.display = 'block');
        } else {
          document.body.classList.remove('expand-menu');
          document.querySelectorAll('.subdrop + ul').forEach((ul) => ul.style.display = 'none');
        }
        return false;
      }
    }

    document.addEventListener('mouseover', handleMouseOver);

    return () => {
      document.removeEventListener('mouseover', handleMouseOver);
    };
  }, []);

  // useEffect(() => {
  //   $(document).on('change', '.sidebar-type-four input', function() {
  //     if($(this).is(':checked')) {
  //         $('.sidebar').addClass('sidebar-eight');
  //         $('.sidebar-menu').addClass('sidebar-menu-eight');
  //         $('.menu-title').addClass('menu-title-eight');
  //         $('.header').addClass('header-eight');
  //         $('.header-left-two').addClass('header-left-eight');
  //         $('.user-menu').addClass('user-menu-eight');
  //         $('.dropdown-toggle').addClass('dropdown-toggle-eight');
  //         $('.white-logo').addClass('show-logo');
  //         $('.header-one .header-left-one .logo:not(.logo-small), .header-five .header-left-five .logo:not(.logo-small)').addClass('hide-logo');
  //         $('.header-two .header-left-two .logo:not(.logo-small)').removeClass('hide-logo');
  //         $('.header-two .header-left-two .dark-logo').removeClass('show-logo');
  //     } else {
  //         $('.sidebar').removeClass('sidebar-eight');
  //         $('.sidebar-menu').removeClass('sidebar-menu-eight');
  //         $('.menu-title').removeClass('menu-title-eight');
  //         $('.header').removeClass('header-eight');
  //         $('.header-left-two').removeClass('header-left-eight');
  //         $('.user-menu').removeClass('user-menu-eight');
  //         $('.dropdown-toggle').removeClass('dropdown-toggle-eight');
  //         $('.white-logo').removeClass('show-logo');
  //         $('.header-one .header-left-one .logo:not(.logo-small), .header-five .header-left-five .logo:not(.logo-small)').removeClass('hide-logo');
  //     }
  // });
  // }, [])



  let pathName = loction.pathname

  console.log("Working", pathName);


  return (
    <>
      <div className="sidebar" id="sidebar">
        {/* <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        > */}
        <div className="sidebar-inner slimscroll" style={{backgroundColor:secondaryColor}}>
          <div id="sidebar-menu" className="sidebar-menu">
            {/* Main Menu */}
            <ul>
              <li className="menu-title" >
                <span style={{color:textColor}}>Main Menu</span>
              </li>
              <li
                className={`${"/dashboard" === pathName ? "active" : ""
                  }`} 
              >
                <Link to="/dashboard">
                  {/* <i className="fas fa-holly-berry" />  */}
                  <RxDashboard color={textColor} />
                  <span style={{color:textColor}}>Dashboard</span>
                </Link>
              </li>


              <li
                className={`${"/user-list" === pathName ||
                  "/add-user" === pathName
                  ? "active submenu"
                  : "submenu"
                  }`}
              >
                <Link
                  to="#"
                  className={isSideMenu == "usermenu" ? "subdrop" : ""}
                  onClick={() =>
                    toggleSidebar(
                      isSideMenu == "usermenu" ? "" : "usermenu"
                    )
                  }
                >
                  {/* <i className="fas fa-building" />  */}
                  <AiOutlineTeam  color={textColor}/>
                  <span style={{color:textColor}}> Card User</span>{" "}
                  {/* <span className="menu-arrow" /> */}
                  <IoIosArrowForward className="menu-arrow"  color={textColor}/>
                 

                </Link>
                {isSideMenu == "usermenu" ? (
                  <ul
                    style={{
                      display: isSideMenu == "usermenu" ? "block" : "none",
                    }}
                  >
                    <li>
                      <Link
                        to="/user-list"
                        className={`${"/user-list" === pathName ? "active" : ""
                          }`}
                          style={{color:textColor}}
                      >
                        User List
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/add-user"
                        className={`${"/add-user" === pathName ? "active" : ""
                          }`}
                          style={{color:textColor}}
                      >
                        User Add
                      </Link>
                    </li>

                  </ul>
                  
                ) : (
                  ""
                )}
              </li>


              


            </ul>
            <ul>
              <li
                className={`${
           
                  "/interface" === pathName
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/interface">
                  <BiSolidMobile color={textColor} />
                  <span style={{color:textColor}}>InterFace</span>
                </Link>
              </li>
            </ul>
            <ul>
              <li
                className={`${
           
                  "/enquiry" === pathName
                    ? "active"
                    : ""
                }`}
              >
                <Link to="/enquiry">
                  <IoIosPeople color={textColor} />
                  <span style={{color:textColor}}>Enquiry List</span>
                </Link>
              </li>
            </ul>








          </div>
        </div>
        {/* </Scrollbars> */}
      </div>
    </>
  );
};
export default Sidebar;
